<template>
  <!-- 海报正文 -->
  <div class="toimg" style="transform: scale(0.5)">
    <div class="posterContent">
      <div class="shopImg">
        <img class="shop-img" id="shopImg" :src="shopImg" />
      </div>
      <div class="shopName">{{ name }}</div>
      <div class="separator"></div>
      <div class="shopPrice">
        <div class="priceUnits">￥</div>
        <div class="price">{{ price }}</div>
      </div>
      <div class="shopQrcode">
        <img :src="qrCode" class="shop-qrcode" />
      </div>
      <div class="qr-text"><div>扫码立即下单</div></div>
      <div class="brandImg"></div>
      <img
        class="brandImg"
        :src="require('@/assets/images/poster/logo_gnp@2x.png')"
      />
      <div class="brandContent"><div>成都德国国家商品馆</div></div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    showPoster: {
      default: true,
    },
    name: { default: '' },
    image: { default: '' },
    price: { default: '' },
    qrCode: { default: '' },
  },
  data() {
    return {
      show: false,
      testImg: 'url(' + require('@/assets/images/poster/logo_gnp@2x.png') + ')',
      shopImg: '',
      imgSrc: '',
      showimg: false,
      load: true,
    }
  },
  beforeMount() {},
  mounted() {
    window.onresize = () => {
      try {
        this.resize()
      } catch (error) {
        console.log()
      }
    }
  },
  methods: {
    resize() {
      var scale = (
        document.querySelector('.posterContainer').clientWidth / 300
      ).toFixed(2)
      document.querySelector('.toimg').style.transform = `scale(${scale})`
    },
    imgResize() {
      let img = document.getElementById('shopImg')
      // console.log('图片高度', img.clientHeight)
      // console.log('图片宽度', img.clientWidth)
      img.removeAttribute('style')
      if (img.clientHeight < img.clientWidth) {
        img.setAttribute(
          'style',
          'height:300px;left:50%;transform: translateX(-50%);'
        )
        // img.style.height='300px';
      } else {
        // img.style.width='300px';
        img.setAttribute(
          'style',
          'width:300px;top:50%;transform: translateY(-50%);'
        )
      }
      // console.log('图片高度', img.clientHeight)
      // console.log('图片宽度', img.clientWidth)
    },
  },
  watch: {
    //显示弹出框
    name() {
      // this.show = this.showPoster
      if (this.image) {
        this.shopImg = this.image
      } else {
        this.shopImg = require('@/assets/images/poster/img_item@2x.png')
      }
      // this.imgResize()
    },
  },

  updated() {
    // console.log('容器宽度',document.querySelector('.posterContainer').clientWidth)
    // console.log('容器高度',document.querySelector('.posterContainer').clientHeight)
    // 海报自适应
    try {
      this.resize()
      this.imgResize()
    } catch (error) {
      console.log()
    }
    window.onresize = () => {
      try {
        this.resize()
      } catch (error) {
        console.log()
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.toimg {
  position: relative;
  top: calc((100% - 533.3333px) / 2);
  left: calc((100% - 300px) / 2);
  width: 300px;
  height: 533.3333px;
  box-shadow: 0 4px 15px 0 #f6f6f6;

  .posterContent {
    width: 300px;
    height: 533.3333px;
    position: absolute;
    box-shadow: 0 4px 10px 0 rgba(44, 63, 88, 0.6);
    .shopImg {
      position: absolute;
      top: 0;
      width: 300px;
      height: 300px;
      // object-fit: cover;
      overflow: hidden;
      .shop-img {
        display: block;
        position: absolute;
        // width: 300px;
        // top: 50%;
        // transform: translateY(-50%);
      }
    }
    .shopName {
      position: absolute;
      left: 12px;
      top: 308px;
      display: inline-block;
      width: 186.93px;
      height: 36px;
      font-family: PingFangSC-Medium;
      font-weight: 550;
      font-size: 13px;
      color: #404245;
      letter-spacing: 0;
      line-height: 18px;
      text-align: left;
    }
    .separator {
      width: 0px;
      height: 72px;
      border: 1px solid rgba(94, 88, 115, 1);
      border-width: 0 1px 0 0;
      position: absolute;
      top: 291.69px;
      left: 200.51px;
      transform: scale(0.5);
    }
    .shopPrice {
      width: 75.09px;
      height: 31.82px;
      position: absolute;
      left: 208.51px;
      top: 309.69px;
      .priceUnits {
        width: 12.98px;
        height: 27.2px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        font-size: 13px;
        color: #404245;
        letter-spacing: 0;
        text-align: left;
        line-height: 27.2px;
        display: inline-block;
      }
      .price {
        width: 33.95px;
        height: 19.2px;
        font-family: SFProText-Bold;
        font-weight: Bold;
        font-size: 16px;
        color: #404245;
        letter-spacing: 0;
        text-align: left;
        line-height: 19.2px;
        padding-left: 0.6px;
        display: inline-block;
      }
    }
    .shopQrcode {
      width: 100px;
      height: 100px;
      position: absolute;
      left: 98px;
      top: 360px;
      .shop-qrcode {
        width: 100px;
      }
    }
    .qr-text {
      width: 260px;
      height: 28px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 20px;
      color: #404245;
      letter-spacing: 0;
      position: absolute;
      left: 20px;
      top: 455px;
      div {
        text-align: center;
        font-size: 20px;
        transform: scale(0.5);
      }
    }

    .brandImg {
      display: block;
      width: 26.7px;
      height: 26.7px;
      position: absolute;
      left: 247.74px;
      top: 469.64px;
    }
    .brandContent {
      width: 108px;
      height: 44px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 16px;
      color: #404245;
      letter-spacing: 0;
      text-align: center;
      position: absolute;
      left: 207px;
      top: 489px;
      text-align: center;
      div {
        transform: scale(0.5);
      }
    }
  }
}
</style>
